import {
  cancelRentalPortalPublicationSchedule,
  deactivateRentalPortalListingPortals,
  publishRentalPortalListingPortals,
  retryRentalPortalPublication,
  updateRentalPortalListingPortals,
  updateRentalPortalPublication,
} from '../../../../../../../api'
import {
  LISTING_PUBLICATION_ACTION,
  LISTING_PUBLICATION_SCHEDULE_FIELD,
  LISTING_PUBLICATION_SCHEDULE_TYPE,
} from '../../RentalPortalListingProfilePublishings.constants'

export function performListingPublicationAction({
  action,
  listingId,
  publication,
  scheduledAt,
}) {
  switch (action) {
    case LISTING_PUBLICATION_ACTION.publish:
    case LISTING_PUBLICATION_ACTION.publishNow:
    case LISTING_PUBLICATION_ACTION.republish:
      return publishRentalPortalListingPortals({
        data: {
          deactivate_at: publication.scheduled_deactivate_at,
          portals: [publication.portal],
          publish_at: null,
        },
        id: listingId,
      })
    case LISTING_PUBLICATION_ACTION.resend:
    case LISTING_PUBLICATION_ACTION.transferChanges:
      return updateRentalPortalListingPortals({
        data: { portals: [publication.portal] },
        id: listingId,
      })
    case LISTING_PUBLICATION_ACTION.deactivate:
      return deactivateRentalPortalListingPortals({
        data: { deactivate_at: null, portals: [publication.portal] },
        id: listingId,
      })
    case LISTING_PUBLICATION_ACTION.retry:
      return retryRentalPortalPublication(publication.id)
    case LISTING_PUBLICATION_ACTION.cancelSchedule:
      return cancelRentalPortalPublicationSchedule({
        id: publication.id,
        scheduleType: LISTING_PUBLICATION_SCHEDULE_TYPE.publish,
      })
    case LISTING_PUBLICATION_ACTION.cancelDeactivation:
      return cancelRentalPortalPublicationSchedule({
        id: publication.id,
        scheduleType: LISTING_PUBLICATION_SCHEDULE_TYPE.deactivate,
      })
    default:
      return updateRentalPortalPublication({
        data: {
          [LISTING_PUBLICATION_SCHEDULE_FIELD[action]]: scheduledAt ?? null,
        },
        id: publication.id,
      })
  }
}
